/* eslint-disable no-plusplus */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useRef } from 'react';

import { NavLink } from 'react-router-dom';
import MaskedInput from 'react-text-mask';
import classNames from 'classnames';

import Tooltip from '../../Tooltip';

import currencyMask from '../../../helpers/currencyMask';

export default function CurrencyInput({
  label,
  name,
  value,
  onChange,
  onBlur,
  error,
  touched,
  link,
  tabindex,
  isVisible,
  readOnly,
  disabled,
  tooltip,
  tooltipPosition,
  tooltipSize,
  reference,
}) {
  const ref = useRef();
  const inputRef = reference || ref;

  // Focus on input if tabindex = 1
  useEffect(() => {
    if (tabindex === 1 && inputRef.current) {
      inputRef.current.focus?.();
    }
  }, [tabindex, isVisible, inputRef]);

  return (
    <div>
      <div className="flex items-center gap-2 mb-1">
        <label className="block text-sm font-medium" htmlFor={name}>
          {label}
        </label>
        {tooltip && (
          <Tooltip size={tooltipSize} position={tooltipPosition}>
            {tooltip}
          </Tooltip>
        )}
      </div>
      <div className="relative">
        <MaskedInput
          className={classNames('form-input w-full pl-12 z-10', {
            'border-0 shadow-none': readOnly,
          })}
          mask={currencyMask}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          onBlur={onBlur}
          tabindex={tabindex}
          ref={inputRef}
          readOnly={readOnly || disabled}
        />

        <div className="absolute inset-0 right-auto flex items-center pointer-events-none">
          <span className="text-sm text-slate-400 dark:text-slate-500 font-medium px-3">
            $
          </span>
        </div>
      </div>
      {link && (
        <NavLink
          className="inline-block w-full text-sm underline hover:no-underline text-right"
          to={link.url}
          tabIndex={-1}
        >
          {link.title}
        </NavLink>
      )}
      {error && touched && (
        <div className="text-red-500 text-sm mt-1">{error}</div>
      )}
    </div>
  );
}
